import React from "react"
import { Formik, Field } from "formik"
import { renderTextInput2 } from "components/forms/SharedInputs"
import * as Yup from "yup"
import Checkbox from "@material-ui/core/Checkbox"
import "./SetReminderView.scss"
import ReceiptViewHeader from "./ReceiptViewHeader"

export const SetReminderView = ({ onRequestReminder, onHaveReceiptClick, headline = "Set reminder", bodyCopy = "", introCopy }) => {
  let validationSchema = {
    email: Yup.string().email("Invalid email address").required("Required"),
    confirmation: Yup.bool().oneOf([true], "Required field")
    //confirmation2: Yup.string().required("Please confirm you agree with our Terms & Conditions and Privacy Policy."),
  }
  const initialValues = {
    // formRewardOptions: formRewardOptions[0].value,
    email: "",
    confirmation: false,
  }

  const handleReminderSubmission = async values => {
    
    const { email } = values
    onRequestReminder(email)
   
  }
  const isTheFormValid  = (errors, dirty) => {
    return errors.length === 0 && dirty === true

  }
  return (
    <div className="receipt-view set-reminder-view">
      <ReceiptViewHeader headline={headline} introCopy={introCopy} />

      <div className={`receipt-view-content`}>
        <p dangerouslySetInnerHTML={{ __html: bodyCopy }}></p>
        <Formik
          className={`reminder-formik`}
          key={`reminder-formik`}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={Yup.object(validationSchema)}
          initialValues={initialValues}
          onSubmit={values => {
            handleReminderSubmission(values)
          }}>
          {props => {
            const {  handleSubmit, errors, values, touched, setFieldValue, dirty, isValid } = props
            return (
              <form autocomplete={"on"} className={`receipt-reminder-form`} onSubmit={handleSubmit}>
                <ul className="form__elements">
                  <li className="form__element">
                    <Field name={`email`} autocomplete={`email`} type="email" component={renderTextInput2} variant="filled" label={`Email Address`} placeholder={"Email"} />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </li>
                  <li className="form__element checkbox-row">
                <div className="input-row">
                  <Field type="checkbox" defaultChecked={false} value={values.confirmation} component={Checkbox} name="confirmation" error={errors.confirmation} touched={touched.confirmation && true ? "true" : ""} 
                          onChange={e => { console.log(e.target.value); setFieldValue('confirmation', e.target.checked)}}/>
                  <label htmlFor="confirmation">*By clicking Submit, I acknowledge that I have read and agree to be bound by 
                    the Breaktime Media MWH, LLC <a href="https://www.dailybreak.com/terms" target="_blank">Terms &amp; Conditions</a> and <a href="https://www.dailybreak.com/privacy" target="_blank">Privacy Policy</a>.
                    </label>
                  
                </div>
                {errors.confirmation && <p className="error">{errors.confirmation}</p>}
              </li>

                  <li className="form__submit-wrapper">
                    <div className={`receipt-button-container`}>
                      <button className="btn themed-button-secondary" type="button" onClick={() => onHaveReceiptClick()}>
                      I have my submission
                      </button>
                      <input className="btn themed-button" type="submit" value="Submit" />
                    </div>
                  </li>
                </ul>
              </form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

